import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Aside from "../../components/Aside";
import Api from "../../services/api";
import swal from "sweetalert";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import NewCategoria from "./new";
import EditCategoria from "./edit";
import ReactTooltip from "react-tooltip";

export default function GuiasCategorias() {
  const [loading, setLoading] = useState(true);
  const Loader = () => <div className="loading"></div>;
  const [categorias, setCategorias] = useState([]);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [catEdit, setCatEdit] = useState([]);

  useEffect(() => {
    loadCategorias();
  }, []);

  function loadCategorias() {
    Api.get("/guias/categorias/list")
      .then((r) => {
        setCategorias(r.data);
        setLoading(false);
      })
      .catch((err) => console.error("ops! ocorreu um erro" + err));
  }

  function editCategoria(c) {
    setCatEdit(c);
    setOpenModalEdit(true);
  }

  function deleteCategoria(c) {
    swal({
      title: "Excluir Categoria",
      text: "Deseja realmente excluir a categoria '" + c.nome_pt + "' ?",
      icon: "warning",
      buttons: ["Cancelar", "Excluir"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        Api.delete("/guias/categorias/delete/" + c.id)
          .then((response) => {
            swal(response.data.message, { icon: "success" });
            loadCategorias();
            setLoading(false);
          })
          .catch((err) => {
            swal("ops! ocorreu um erro" + err, { icon: "success" });
            setLoading(false);
          });
      }
    });
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    const rows = categorias.map((c, index) => (
      <div className="item" key={index}>
        <div>
          <a href="#" onClick={() => editCategoria(c)} data-tip="Editar">
            <i className="bx bx-edit"></i>
          </a>
          <a href="#" onClick={() => deleteCategoria(c)} data-tip="Excluir">
            <i className="bx bx-trash"></i>
          </a>
        </div>
        <div>{c.nome_pt}</div>
        <div>{c.url}</div>
        <div>{c.totalguias || 0}</div>
      </div>
    ));

    return (
      <div className="grid">
        <div className="header">
          <div></div>
          <div>Nome</div>
          <div>Slug</div>
          <div>Total guias</div>
        </div>
        <div className="content">{rows}</div>
      </div>
    );
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <ReactTooltip effect="solid" />
      <div className="container-box">
        <Aside />
        <main>
          <div className="top">
            <div>
              <span className="text">Categorias do Guia</span>
              <ul className="breadcrumbs">
                <li>Guia de Experiências</li>
                <li>Categorias</li>
              </ul>
            </div>
            <div>
              <div className="actions top">
                <Link to="#" onClick={() => setOpenModalNew(true)}>
                  <i className="bx bx-plus-circle"></i> Categoria
                </Link>
              </div>
            </div>
          </div>
          {categorias && RenderContent()}
        </main>

        <Modal
          open={openModalNew}
          onClose={() => setOpenModalNew(false)}
          classNames={{ overlay: "customOverlay", modal: "customModal" }}
        >
          <NewCategoria
            loadCategorias={loadCategorias}
            setOpenModalNew={setOpenModalNew}
          />
        </Modal>

        <Modal
          open={openModalEdit}
          onClose={() => setOpenModalEdit(false)}
          classNames={{ overlay: "customOverlay", modal: "customModal" }}
        >
          <EditCategoria
            data={catEdit}
            loadCategorias={loadCategorias}
            setOpenModalEdit={setOpenModalEdit}
          />
        </Modal>
      </div>
    </>
  );
}
